export const FRONT_END_TYPE = {
    XSLAB: "xslab",
    TYPE1: "type1", // 연무 기술
}
